
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/referral/landing",
      function () {
        return require("private-next-pages/account/referral/landing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/referral/landing"])
      });
    }
  